import { DefaultState } from 'store/types';

export const MASS_ACTIONS_REQUEST = 'MASS_ACTIONS_REQUEST';
export const MASS_ACTIONS_SUCCESS = 'MASS_ACTIONS_SUCCESS';
export const MASS_ACTIONS_FAILURE = 'MASS_ACTIONS_FAILURE';

export interface GetMassActionsParams {
  reservationsIds: string[];
}

export interface MassActionsData {
  name: string;
  displayName: string;
  enabled: boolean;
  allowedCount: number;
  errorMessage?: string;
}

export enum MassActionTypes {
  EditReservations = 'EditReservations',
  MoveReservations = 'MoveReservations',
  CancelReservations = 'CancelReservations',
  AddNote = 'AddNote',
}

export interface ReservationssIdsWithStatus {
  id: string;
  status: string;
}

export interface ChangeDatesData {
  toDate?: Date  | null;
  fromDate?: Date  | null;
  doNotSendToGuest?: boolean;
  doNotSendToCLC?: boolean;
};

export type MassActionsState = DefaultState & {
  contents?: MassActionsData[];
}

interface ReadMassActionsRequest {
  type: typeof MASS_ACTIONS_REQUEST;
}

interface ReadMassActionsSuccess {
  type: typeof MASS_ACTIONS_SUCCESS,
  contents: MassActionsData[];
}

interface ReadMassActionsFailure {
  type: typeof MASS_ACTIONS_FAILURE;
}

export type MassActionsActionTypes = ReadMassActionsRequest | ReadMassActionsSuccess | ReadMassActionsFailure;
